import { navbar } from "./components/navbar";
import { main } from "./components/main";
import { service } from "./components/service";
import { bookApp } from "./components/book-app";
import { doctor } from "./components/doctor";
import { contact } from "./components/contact";
import { location } from "./components/location";
import { footer } from "./components/footer";
import { aboutClinic } from "./components/about-clinic";
import { eyeDisease } from "./components/eye-disease";
import { review } from "./components/review";
import { faq } from "./components/faq";
import { aboutCeo } from "./components/about-ceo";
import { aboutEyePriority } from "./components/about-eye-priority";
import { appointmentSect } from "./components/appointment-section";
import { doctorSingle } from "./components/doctor-single";
import { doctorList } from "./components/doctor-list";
import { basic } from "./components/basic";
import { contactPage } from "./components/contactPage";

export const resources = {
  uz: {
    translation: {
      ...navbar.uz,
      ...main.uz,
      ...service.uz,
      ...bookApp.uz,
      ...doctor.uz,
      ...contact.uz,
      ...location.uz,
      ...footer.uz,
      ...aboutClinic.uz,
      ...eyeDisease.uz,
      ...review.uz,
      ...faq.uz,
      ...aboutCeo.uz,
      ...aboutEyePriority.uz,
      ...appointmentSect.uz,
      ...doctorSingle.uz,
      ...doctorList.uz,
      ...basic.uz,
      ...contactPage.uz,
      
    },
  },
  ru: {
    translation: {
      ...navbar.ru,
      ...main.ru,
      ...service.ru,
      ...bookApp.ru,
      ...doctor.ru,
      ...contact.ru,
      ...location.ru,
      ...footer.ru,
      ...aboutClinic.ru,
      ...eyeDisease.ru,
      ...review.ru,
      ...faq.ru,
      ...aboutCeo.ru,
      ...aboutEyePriority.ru,
      ...appointmentSect.ru,
      ...doctorSingle.ru,
      ...doctorList.ru,
      ...basic.ru,
      ...contactPage.ru,
    },
  },
  tj: {
    translation: {
      ...navbar.tj,
      ...main.tj,
      ...service.tj,
      ...bookApp.tj,
      ...doctor.tj,
      ...contact.tj,
      ...location.tj,
      ...footer.tj,
      ...aboutClinic.tj,
      ...eyeDisease.tj,
      ...review.tj,
      ...faq.tj,
      ...aboutCeo.tj,
      ...aboutEyePriority.tj,
      ...appointmentSect.tj,
      ...doctorSingle.tj,
      ...doctorList.tj,
      ...basic.tj,
      ...contactPage.tj,
    },
  },
};
